/** Stable key from applied URL/search filters — ignores result list and loading state. */
export const getAppliedFilterKey = (group = {}) =>
  JSON.stringify({
    account_type: group.account_type ?? "",
    job_title: group.job_title ?? "",
    location: group.location ?? "",
    skill: group.skill ?? "",
    describe_me: group.describe_me ?? "",
    activity: group.activity ?? "",
    gender: group.gender ?? "",
    race: group.race ?? "",
    describe_company: group.describe_company ?? "",
    industry: group.industry ?? "",
    department: group.department ?? "",
    diverse: group.diverse ?? "",
    classifications: group.classifications ?? "",
    markets: group.markets ?? "",
    solopreneur: group.solopreneur ?? "",
    certified: group.certified ?? "",
    verification_type: group.verification_type ?? "",
    level_type: group.level_type ?? "",
    profession: group.profession ?? "",
    experience: group.experience ?? "",
    title: group.title ?? "",
    company_name: group.company_name ?? "",
    category: group.category ?? "",
    country: group.country ?? "",
  })
